// extracted by mini-css-extract-plugin
module.exports = {"container":"Image_container__3ISFj","placeholderContainer":"Image_placeholderContainer__2U47W"};